const convertToUIScore = function (playerScore) {
  let tempScore = {
    startTime: playerScore.startTime,
    laneNumber: playerScore.laneNumber,
    isOldScore: playerScore.isOldScore,
    totalScore: playerScore.turnTotalScore,
    roundScores: [],
  };
  for (let ri = 0; ri < 10; ri++) {
    tempScore.roundScores[ri] = {
      score1: "",
      score2: "",
      score3: "",
      pins1: [],
      pins2: [],
      pins3: [],
      totalScore: "",
    };

    const scoreLength = playerScore.roundScores[ri].scores.length;
    if (scoreLength > 0) {
      tempScore.roundScores[ri].score1 =
        playerScore.roundScores[ri].scores[0].scoreStr;
      tempScore.roundScores[ri].score1Moidified =
        playerScore.roundScores[ri].scores[0].isModified;
      tempScore.roundScores[ri].pins1 =
        playerScore.roundScores[ri].scores[0].pinStates;
    }
    if (scoreLength > 1) {
      tempScore.roundScores[ri].score2 =
        playerScore.roundScores[ri].scores[1].scoreStr;
      tempScore.roundScores[ri].score2Moidified =
        playerScore.roundScores[ri].scores[1].isModified;
      tempScore.roundScores[ri].pins2 =
        playerScore.roundScores[ri].scores[1].pinStates;
    }
    if (scoreLength > 2) {
      tempScore.roundScores[ri].score3 =
        playerScore.roundScores[ri].scores[2].scoreStr;
      tempScore.roundScores[ri].score3Moidified =
        playerScore.roundScores[ri].scores[2].isModified;
      tempScore.roundScores[ri].pins3 =
        playerScore.roundScores[ri].scores[2].pinStates;
    }
    if (playerScore.roundScores[ri].roundTotalScore != null) {
      tempScore.roundScores[ri].totalScore =
        playerScore.roundScores[ri].roundTotalScore;
    }
  }

  return tempScore;
};

export default {
  convertToUIScore,
};
